import { ref } from 'vue';
import { defineStore } from 'pinia';

import type { DestinationInformation } from '@libs/trip-planner-interfaces';

import type { Stay } from '../models';
import { HotelDetailsModalType } from '../models';
import type { StayPriceBreakdownData } from '../../priceBreakdownModal';

export const useHotelDetailsModalsStore = defineStore(
  'HotelDetailsModalsStore',
  () => {
    // State
    const hotelDetailsModalType = ref<HotelDetailsModalType>(
      HotelDetailsModalType.None
    );
    const moreInformationModalFor = ref<StayPriceBreakdownData | undefined>();
    const destinationInformation = ref<DestinationInformation | undefined>();

    // Actions
    function openAmenititesModal(): void {
      hotelDetailsModalType.value = HotelDetailsModalType.Amenitites;
    }

    function openFullHotelDetailsDescriptionModal(): void {
      hotelDetailsModalType.value =
        HotelDetailsModalType.FullHotelDetailsDescription;
    }

    function openFullDestinationDescriptionModal(
      destination: DestinationInformation
    ): void {
      hotelDetailsModalType.value =
        HotelDetailsModalType.FullDestinationDescription;

      destinationInformation.value = destination;
    }

    function openMoreInformatioModal(stay: Stay): void {
      hotelDetailsModalType.value = HotelDetailsModalType.PriceBreakdown;
      moreInformationModalFor.value = { rooms: stay.rooms, price: stay.price };
    }

    function openPriceGuaranteeModal(): void {
      hotelDetailsModalType.value = HotelDetailsModalType.PriceGuarantee;
    }

    function closeModal(): void {
      moreInformationModalFor.value = undefined;
      hotelDetailsModalType.value = HotelDetailsModalType.None;
    }

    return {
      // State
      hotelDetailsModalType,
      moreInformationModalFor,
      destinationInformation,

      // Actions
      openAmenititesModal,
      openFullHotelDetailsDescriptionModal,
      openFullDestinationDescriptionModal,
      openMoreInformatioModal,
      openPriceGuaranteeModal,
      closeModal,
    };
  }
);
